import { CwtCaptchaConfig } from "@mobile/modules/core/captcha.config";
import { environment } from "../../environments/environment";

export const KatchaCaptchaConfig: CwtCaptchaConfig = {
    siteKey: environment.captchaKey
}